import { render, staticRenderFns } from "./QScoreCardHqPromotions.vue?vue&type=template&id=08b28378&scoped=true&"
import script from "./QScoreCardHqPromotions.vue?vue&type=script&lang=js&"
export * from "./QScoreCardHqPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b28378",
  null
  
)

export default component.exports